import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import template from './form-wrapper.html';
import '../modals/save-changes-modal/save-changes-modal';
import { SidebarMenu } from '../sidebar-menu/sidebar-menu';
import { MySiteApp } from '../my-site-app';
import { MySiteRestService } from '@nuskin/my-site-api';
import { BundleUpdateCreate, BannerContent, FeaturedProducts, ProductBundles, AboutYourStore } from '../forms/forms';


/**
 * @customElement
 * @polymer
 */

export class FormWrapper extends PolymerElement {

    constructor() {
        super();
        // eslint-disable-next-line no-undef
        let context = translationService.getCurrentContext();
        // eslint-disable-next-line no-undef
        this.content = translationService.getTranslations(context);
        this.saveForm = null; // wrapped forms will assign its save methods to this property
        this.customBackLocation = null;
        this.mySite = document.querySelector(MySiteApp.is);
        this.languageSpecificForms = [
            BannerContent.is,
            FeaturedProducts.is,
            AboutYourStore.is,
            ProductBundles.is
        ]
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return 'form-wrapper';
    }

    static get properties() {
        return {
            valid: {
                type: Boolean,
                value: false,
                notify: true
            },
            touched: {
                type: Boolean,
                notify: true
            }
        }
    }

    ready() {
        super.ready();
        // valdiate each form field
        this.validate = () => {
            let inputs = this.childNodes[0].formFields || [];
            inputs.forEach(input => {
                input.validate();
                if(!input.valid) this.setFormValidity(false)
            });
        }
        // fires form-touched-changed event
        this.formTouched = () => {
            // trigger event
            this.touched = !this.touched;
            // set form touched
            this.touched = true;
        }

        // fires form-valid-changed event
        this.setFormValidity = value => {
            // trigger event
            this.valid = !this.formValid;
            // set form validity
            this.valid = value;
        }

        this.setCustomBackLocation = location => {
            this.set('customBackLocation', location);
        }

        this.resetBackLocation = () => {
            this.set('customBackLocation', SidebarMenu.is);
        }

        // checks if form has all required fields as not empty then fires `form-valid-changed` event on every form field change.
        this.formChanged = () => {
            let formValid = true;
            // check if at least one input doesn't have a value
            let fields = this.childNodes[0].formFields || [];
            fields.forEach(field => {
                // exception for ns-sortable:
                if(field.localName === 'ns-sortable') {
                    if ((!field.items || !field.items.length) && field.required) 
                        formValid = false;
                } else {
                    if (!field.value && field.required) 
                        formValid = false;
                }
            });

            this.setFormValidity(formValid);
        }
    }

    updateAndNotify(newValue, marketSpecific, languageSepcific, field, forceNotify) {
        if(!this.mySite.mySiteData) return;
        let subdomain = Object.keys(this.mySite.mySiteData.storefront)[0];
        let currentValue;
        let lang = this.mySite.currentLanguage;
        let ctry = this.mySite.currentMarket;
        // update
        if(!marketSpecific && !languageSepcific) {
            currentValue = this.mySite.mySiteData[field];
            this.mySite.mySiteData[field] = newValue;
        }

        if(marketSpecific && !languageSepcific) {
            currentValue = this.mySite.mySiteData.storefront[subdomain][ctry][field];
            this.mySite.mySiteData.storefront[subdomain][ctry][field] = newValue;
        }

        if(marketSpecific && languageSepcific) {
            currentValue = this.mySite.mySiteData.storefront[subdomain][ctry].lang[lang][field];
            this.mySite.mySiteData.storefront[subdomain][ctry].lang[lang][field] = newValue;
        }
        // notify
        if(this.valuesDoNotMatch(currentValue, newValue) || forceNotify) {
            this.mySite.dispatchEvent(new CustomEvent('my-site-data-changed', {detail: {value: this.mySite.mySiteData}}));
        }
    }

    valuesDoNotMatch(currentValue, newValue) {
        return JSON.stringify(currentValue) !== JSON.stringify(newValue);
    }

    connectedCallback() {
        super.connectedCallback();
        this.resetData();
        this.addEventListener('valid-changed', this._handleFormChanges);
        this.addEventListener('touched-changed', this._handleFormTouch);
        this.addEventListener('save-changes-modal-says-save', this._handleSaveChanges);
        this.addEventListener('save-changes-modal-says-discard', this._handleDiscardChanges);
    
        this.mySite.addEventListener('on-menu-item-click', this._handleMenuSlide.bind(this))
    // this.observer = new MutationObserver(this._onMutation.bind(this));
    // let config = { attributes: true, childList: true, subtree: true };
    // this.observer.observe(document.querySelector(MySiteApp.is).$.mySiteSidebarWrapper, config);
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this.resetData();
        this.removeEventListener('valid-changed', this._handleFormChanges);
        this.removeEventListener('touched-changed', this._handleFormTouch);
        this.removeEventListener('save-changes-modal-says-save', this._handleSaveChanges);
        this.removeEventListener('save-changes-modal-says-discard', this._handleDiscardChanges);
    // this.observer.disconnect();
    }

    resetData() {
        this.discardBtnClass = 'disabled';
        this.formWasUpdatedButNotSaved = false;
        this.$.saveButton.disabled = true;
        this.saving = false;
        this.additionalData = null
    }

    goBack(e) {
        if (e && this.formWasUpdatedButNotSaved) {
            this.mySite.$.saveChangesModal.toggle();
        } else {
            if(this.mySite.currentForm === BundleUpdateCreate.is) // exception handling
                this.mySite.currentForm = ProductBundles.is;
            else // default behavior
                this.mySite.currentForm = SidebarMenu.is; 

            // sticky footer handling
            // if(this.$.savePublish.className.indexOf('sticky') !== -1)
            //   this.$.savePublish.className += ' hide';

            this.dispatchEvent(new CustomEvent('on-menu-item-click', {
                composed: true,
                detail: { 
                    item: this.customBackLocation || SidebarMenu.is,
                    toggleDrawer: this.formWasUpdatedButNotSaved,
                    additionalData: this.additionalData || null
                }
            }));
            this.resetData();
        }
    }

    _handleMenuSlide(e){
        if(e.detail.item !== this.children[0].localName) return;

        setTimeout(() => {
            // let mySite = document.querySelector(MySiteApp.is);
            // let windowHeight = mySite.$.drawerWrapper.offsetHeight;
            let formWrapperHeight = this.offsetHeight;

            if(!formWrapperHeight) return;
      
            // if(windowHeight < formWrapperHeight) {
            //   if(this.$.sidebarFormWrapper.className.indexOf('sticky') === -1)
            //     this.$.sidebarFormWrapper.className += ' sticky';
            //   if(this.$.savePublish.className.indexOf('sticky') === -1)
            //     this.$.savePublish.className += ' sticky';
            // } else {
            //   this.$.sidebarFormWrapper.className = this.$.sidebarFormWrapper.className.split(/\s?sticky/).join('');
            //   this.$.savePublish.className = this.$.savePublish.className.split(/\s?sticky/).join('');
            // }
            // this.handleStickyFooterPopUp();
        }, 500)

    }

    _handleDiscardChanges() {
        if(this.mySite.$.menuPages.selected !== this.children[0].localName) return;
        this.resetData();
        this.goBack();
    }

    _handleSaveChanges() {
        if(this.mySite.$.menuPages.selected !== this.children[0].localName) return;
        this.$.saveButton.disabled = true;
        this.validate();
        if(this.valid) {
            this.saving = true;
            this.formWasUpdatedButNotSaved = false;
            this.mySite.dispatchEvent(new CustomEvent('savingForm'));
            let promise = this.saveForm();
            // saveForm should return a promise so that we can do form slide animation after successfull save (on desktop)
            if (promise) {
                promise.then(async () => {
                    // save 'last editied' date if form has language specific content
                    if(this.languageSpecificForms.indexOf(this.mySite.currentForm) !== -1) {
                        let sponsorData = await MySiteRestService.touchLanguage(this.mySite.currentMarket, this.mySite.currentLanguage);
                        this.updateAndNotify(sponsorData.storefront, false, false, 'storefront', true);
                    }
                    // go back
                    this.goBack();
                });
            } else {
                this.goBack();
            }
        }
    }

    _handleFormTouch() {
        if(this.mySite.$.menuPages.selected !== this.children[0].localName || this.saving) return;
        this.formWasUpdatedButNotSaved = true;
        // form has been touched, so activate 'Discard Changes' button
        this.discardBtnClass = 'active';
        this.$.saveButton.disabled = !this.formWasUpdatedButNotSaved || !this.valid;
        this.handleStickyFooterPopUp();
    }

    _handleFormChanges() {
        if(this.mySite.$.menuPages.selected !== this.children[0].localName) return;
        // disable 'SAVE' button untill form is valid
        this.$.saveButton.disabled = !this.formWasUpdatedButNotSaved || !this.valid;
        this.handleStickyFooterPopUp();
    }

    // pops `save and publish` buttons when form was touched/changed
    handleStickyFooterPopUp() {
    // this.$.savePublish.className = this.$.saveButton.disabled && this.discardBtnClass 
    //   ? (this.$.savePublish.className.indexOf('hide') === -1 ? this.$.savePublish.className + ' hide' : this.$.savePublish.className)
    //   : this.$.savePublish.className.split(/\s?hide/).join('');
    } 

}

window.customElements.define(FormWrapper.is, FormWrapper);
